import { useEffect, useState } from "react"

import { FieldData, mapFilters } from "@/components/_Shared/FilterWrapper"

import { useCustomerQuery } from "@/hook/Dictionaries/Customers/useCustomerQuery"
import { useDepotSelectListQuery } from "@/hook/Dictionaries/useDepotQuery"
import { useFilterStorage } from "@/hook/useFilterStorage"

import { ORDER_REPORT_KEY } from "@/types/IOrderReport"
import { FilterField, FilterFieldOperator, FilterFieldType } from "@/types/ui"


export const useOrderReportFilters = () => {
  const [filters, setFilters] = useState<FilterField[]>([])

  const { getFilter } = useFilterStorage({
    key: ORDER_REPORT_KEY
  })

  const oldFilters: FieldData[] = getFilter()

  const { data: depots } = useDepotSelectListQuery()
  const { data: customers } = useCustomerQuery()

  useEffect(() => {
    setFilters([
      {
        text: "Дата",
        name: "date",
        type: FilterFieldType.DateRange
      },
      {
        text: "Нефтебаза",
        name: "depotId",
        values: depots?.response.map((f) => ({
          id: f.id,
          name: f.name
        })) ?? [],
        type: FilterFieldType.Select
      },      
      {
        text: "Номенклатура",
        name: "fuelTypeName",
        operator: FilterFieldOperator.Contains,
        type: FilterFieldType.Text
      },
      {
        text: "Контрагент",
        name: "CustomerId",
        type: FilterFieldType.MultiSelect,
        values: customers?.response.data
      }
    ])
  }, [depots, customers])

  return mapFilters(filters, oldFilters)
}